export default __webpack_public_path__ + "static/media/logo-2.ac21e3be.png";